import { formatCurrency } from '@chilecompra/react-kit'
import { formatOtherCurrency } from './formatters'
import { CURRENCY_SIGNS } from '../../config/settings/constants'

/**
 * Formats a numeric value as a currency string, optionally prepending the
 * appropriate symbol for the given currency type. The function ensures that both
 * the currency type and value are provided; otherwise, it returns an empty string.
 *
 * - If the currency type (`typeCurrency`) or the value (`value`) is missing,
 *   the function will return an empty string to prevent malformed outputs.
 *
 * @param {string} typeCurrency - The currency code (e.g., 'CLP', 'EUR') that determines the symbol.
 * @param {number} value - The numeric value to format.
 * @param {boolean} shouldReturnSymbol - Indicates whether to prepend the currency symbol.
 *
 * @returns {string} - A formatted currency string with the currency symbol or an empty string if inputs are invalid.
 */
export const formatTypeCurrency = (typeCurrency, value, shouldReturnSymbol = false) => {
  if (!typeCurrency || !value) return ''

  const decimalPlaces = {
    CLP: 0,
    USD: 2,
    EUR: 2,
    UTM: 4,
    CLF: 4,
    default: 2
  }

  const places = decimalPlaces[typeCurrency] || decimalPlaces.default

  const formattedValue =
    typeCurrency === 'CLP' ? formatCurrency(parseInt(value, 10)) : formatOtherCurrency(value, places, '.', ',')

  const symbol = shouldReturnSymbol ? `${CURRENCY_SIGNS[typeCurrency] || ''} ` : ''

  return `${symbol}${formattedValue}`
}
